export default __webpack_public_path__ + "static/media/style3-loading.8825047c.svg";